import Button from "./Button";

const Controls = {
  Button,
};

export default Controls;